var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefreshIcon = function SvgRefreshIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0L3.125 2.5L5.625 5V3.125C8.03687 3.125 10 5.0875 10 7.5C10 8.05 9.89328 8.57506 9.70703 9.06006L10.6543 10.0061C11.0324 9.25048 11.25 8.40125 11.25 7.5C11.25 4.39875 8.72688 1.875 5.625 1.875V0ZM0.595703 4.9939C0.217578 5.74952 0 6.59875 0 7.5C0 10.6012 2.52313 13.125 5.625 13.125V15L8.125 12.5L5.625 10V11.875C3.21312 11.875 1.25 9.9125 1.25 7.5C1.25 6.95 1.35672 6.42494 1.54297 5.93994L0.595703 4.9939Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefreshIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refreshIcon.0f76412c.svg";
export { ForwardRef as ReactComponent };